import { CustomConnectorDto } from '@/models/connectors';

/** Shown when the INPUT connectors API is unavailable so the catalog section still renders. */
export const PLACEHOLDER_SOURCE_CONNECTORS: CustomConnectorDto[] = [
  {
    id: 'D365_BUSINESS_CENTRAL',
    name: 'Microsoft Dynamics 365 Business Central',
    description: 'Pull customers, contacts, and vendors from Business Central.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    active: true,
    publicAvailable: true,
    resolver: 'D365_BUSINESS_CENTRAL',
    isAuthenticated: false,
    authConfiguration: {
      configurations: [
        {
          version: '1',
          elements: {
            auth: {
              type: 'credentials',
              config: {},
              reactJsonSchemaForm: {
                formId: 'd365-bc-auth',
                title: 'Connect to Business Central',
                schema: {
                  type: 'object',
                  required: ['tenantId', 'clientId', 'clientSecret'],
                  properties: {
                    tenantId: { type: 'string', title: 'Tenant ID' },
                    clientId: { type: 'string', title: 'Client ID' },
                    clientSecret: { type: 'string', title: 'Client Secret' },
                    environment: { type: 'string', title: 'Environment', default: 'production' },
                  },
                },
                uiSchema: {
                  clientSecret: { 'ui:widget': 'password' },
                },
              },
            },
          },
        },
      ],
    },
  },
];
